module.exports = __webpack_public_path__ + "img/priority-med.2b902299.svg";